"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_BANK_MANAGEMENT_PERMISSIONS = exports.BankManagementPermissions = void 0;
/**
 * Permission string catalog for Bank Management (Stage 13, Milestone 2
 * Part 3) — Bank Account master, Bank Deposit, Bank Withdrawal, Bank
 * Transfer (bank-to-bank only, see ADR-029), Cheque Management (both
 * directions), and the Bank Book/Summary reports.
 */
exports.BankManagementPermissions = {
    /** Bank Account master CRUD + setPrimary. */
    BANK_ACCOUNT_MANAGE: 'bank-management:account:manage',
    /**
     * READ the Bank Account master — list and get-by-id only.
     *
     * Split out from MANAGE because taking a card or UPI payment requires
     * NAMING the account the money lands in, so every cashier has to be able to
     * read this list. With one combined key that meant handing a receptionist
     * `create` and `set-primary` as well — the authority to add a bank account
     * and redirect where the hospital's card takings post. A cashier chooses
     * among the accounts; a controller decides which accounts exist.
     *
     * MANAGE still satisfies the reads (see `requireAnyPermission` on the GET
     * routes), so nobody who could read this list before has lost anything.
     */
    BANK_ACCOUNT_READ: 'bank-management:account:read',
    /** createDeposit, markDeposited, cancel. */
    BANK_DEPOSIT_CREATE: 'bank-management:deposit:create',
    /** create, submit — Bank Withdrawal. */
    BANK_WITHDRAWAL_CREATE: 'bank-management:withdrawal:create',
    /** approve/reject/complete a Bank Withdrawal. */
    BANK_WITHDRAWAL_APPROVE: 'bank-management:withdrawal:approve',
    /** create, submit — Bank Transfer. */
    BANK_TRANSFER_CREATE: 'bank-management:transfer:create',
    /** approve/reject/complete a Bank Transfer. */
    BANK_TRANSFER_APPROVE: 'bank-management:transfer:approve',
    /** receiveCheque, issueCheque, markDeposited/Presented, clear, bounce, cancel. */
    CHEQUE_MANAGE: 'bank-management:cheque:manage',
    /** Bank Book (per bank account ledger + deposit/withdrawal/transfer status). */
    BANK_BOOK_READ: 'bank-management:bank-book:read',
    /** Bank Summary (balance, deposits, withdrawals, outstanding cheques). */
    BANK_SUMMARY_READ: 'bank-management:summary:read',
};
exports.ALL_BANK_MANAGEMENT_PERMISSIONS = Object.values(exports.BankManagementPermissions);
//# sourceMappingURL=bank-management.permissions.js.map